import { setSpecificMessage, nonEmpty } from "valibot";
setSpecificMessage(
  nonEmpty,
  (issue) => `Longeur invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);